module.exports = __webpack_public_path__ + "img/swift-sport-amarillo-rally.617ff19f.png";